import { render, staticRenderFns } from "./EditorSectionLabel.vue?vue&type=template&id=9c72b5d2&scoped=true"
import script from "./EditorSectionLabel.vue?vue&type=script&lang=js"
export * from "./EditorSectionLabel.vue?vue&type=script&lang=js"
import style0 from "./EditorSectionLabel.vue?vue&type=style&index=0&id=9c72b5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c72b5d2",
  null
  
)

export default component.exports